module.exports = __webpack_public_path__ + "media/img/uploads/search-result-01-e83976d70637a9e2b7dccb3eabc38c06.jpg";